export default {
  error: require('./error/error.svg'),
  creditCard: require('./creditcard/credit-card-icon.svg'),
  success: require('./success/success.svg'),
  important: require('./important/impoprtant.svg'),
  updateicon: require('./updateicon/icon-120-update.svg'),
  importantIcon: require('./important/importnant-exc-mark.svg'),
  arrowLeft: require('./important/back-arrow.svg'),
};
